// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  background: white;
  border-radius: 8px;
  padding: 32px 24px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.3s ease;
}
.error-modal .error-icon {
  height: 72px;
  width: 72px;
  margin-bottom: 8px;
}
.error-modal h2 {
  font-family: AppFontBold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 22px;
}
.error-modal p {
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-wrap: balance;
  color: #393939;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACD;AACE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAGE,kBAAA;EACF,cAAA;EACE,mBAAA;AAHJ","sourcesContent":[".error-modal {\n\tbackground: white;\n\tborder-radius: 8px;\n\tpadding: 32px 24px;\n\twidth: 100%;\n\ttext-align: center;\n\tanimation: slideUp 0.3s ease;\n\n  .error-icon {\n    height: 72px;\n    width: 72px;\n    margin-bottom: 8px;\n  }\n\n\th2 {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 24px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 22px;\n\t}\n\n\tp {\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\t// text-transform: capitalize;\n\n    text-wrap: balance;\n\t\tcolor: #393939;\n    margin-bottom: 16px;\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
